// extracted by mini-css-extract-plugin
export default {"container":"OneRecibo_container__t0fQI","labeldatafactura":"OneRecibo_labeldatafactura__6Xbb7","btnfel":"OneRecibo_btnfel__3tbVN"};